import { render, staticRenderFns } from "./PlayerSeasonsTable.vue?vue&type=template&id=64bb9fe1&scoped=true&"
import script from "./PlayerSeasonsTable.vue?vue&type=script&lang=js&"
export * from "./PlayerSeasonsTable.vue?vue&type=script&lang=js&"
import style0 from "./PlayerSeasonsTable.vue?vue&type=style&index=0&id=64bb9fe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bb9fe1",
  null
  
)

export default component.exports